import React from "react";
import { ArrowPathIcon } from "@heroicons/react/24/outline";

import classes from "./classes.module.scss";

interface IProps {
	className?: string;
	width?: string | number;
	color?: string;
}
export default class Loader extends React.Component<IProps> {
	public override render(): React.JSX.Element {
		return <ArrowPathIcon className={classes["root"]} color={this.props.color} width={this.props.width} />;
	}
}
